export default __webpack_public_path__ + "static/media/bg01.2bad2baf.jpg";